export default "__VITE_ASSET__KCphI3wKKNfCtwugublVEg__"